const reportSignatureButton = '1cm';
const reportSignatureHeight = '3cm';
const acceptanceSignatureButton= '19.1cm';
const acceptanceSignatureHeight = '5.5cm';

function lb(left: string, bottom: string) {
  return { left: left, bottom: bottom };
}

function lt(left: string, top: string) {
  return { left: left, top: top };
}

function dim(width: string, height: string) {
  return { width: width, height: height };
}

const resultTopOffset = '10.65cm';
const pictureTopOffset = '17.4cm';

export const orderDialogPositions: any = {
  agb: {
    signature: {
      pos: lb('11cm', '1cm'),
      canvas: dim('8.5cm', '4.5cm')
    }
  },
  acceptance: {
    damage: {
      pos: lt('2.5cm', '4.5cm'),
      canvas: dim('18cm', '10.5cm')
    },
    damageNote: {
      pos: lt('3.2cm', '16.7cm'),
      switch: lt('0.5cm', '16.7cm'),

      canvas: dim('15.2cm', '11cm'),
      clearPos: lb('19.1cm', '1.5cm')
    },
    customerSignature: {
      pos: lt('1.9cm', acceptanceSignatureButton),
      canvas: dim('8.2cm', acceptanceSignatureHeight)
    },
    montageSignature: {
      pos: lt('11cm', acceptanceSignatureButton),
      canvas: dim('8.2cm', acceptanceSignatureHeight)
    },
  },
  receipt: {
    signature: {
      pos: lb('13.1cm', '5cm'),
      canvas: dim('6.75cm', '4cm')
    }
  },
  report: {
    damage: {
      pos: lt('8.7cm', '15.7cm'),
      canvas: dim('10.7cm', '3.5cm')
    },
    customerSignature: {
      pos: lb('2.5cm', reportSignatureButton),
      canvas: dim('7.5cm', reportSignatureHeight)
    },
    montageSignature: {
      pos: lb('10.9cm', reportSignatureButton),
      canvas: dim('7.5cm', reportSignatureHeight)
    },
    resultOK: lt('10.6cm', resultTopOffset),
    resultNotOK: lt('13.8cm', resultTopOffset),
    montageTypeRepair: lt('4.95cm', '9.35cm'),
    montageTypeReplace: lt('13.85cm', '9.3cm'),
    pictureYes: lt('2.85cm', pictureTopOffset),
    pictureNo: lt('5.37cm', pictureTopOffset)
  }
};

